import React from 'react';
import { connect } from 'react-redux';

import PurchaseModal from 'components/Fate/components/PurchaseModal/PurchaseModalContainer';
import { IAppState } from 'types/app';

type Props = ReturnType<typeof mapStateToProps> & {
  isOpen: boolean,
  onRequestClose: () => void,
};

export function RefreshActionsModal({ fateData, isOpen, onRequestClose }: Props) {
  const data =fateData.fateCards.find(({ action }: { action: string }) => action === 'RefillActions');
  return (
    <PurchaseModal
      data={data}
      isOpen={isOpen}
      onRequestClose={onRequestClose}
    />
  );
}

const mapStateToProps = (state: IAppState) => ({
  fateData: state.fate.data,
});

export default connect(mapStateToProps)(RefreshActionsModal);
